export default {
  'webhookParameters.form.parameter': 'Parameter',
  'webhookParameters.form.addParameter': 'Add parameter',
  'webhookParameters.form.noParameters': 'No parameters yet. Add at least one.',
  'webhookParameters.form.inputParameterPosition': 'Parameter position',
  'webhookParameters.form.inputParameterName': 'Parameter name',
  'webhookParameters.form.inputParameterCodification': 'Parameter codification',
  'webhookParameters.form.destination': 'Destination',
  'webhookParameters.form.destinationForm': 'Destination form',
  'webhookParameters.form.destinationField': 'Destination field',
  'webhookParameters.form.destinationFieldValueDestination': 'Destination field value type',
  'webhookParameters.form.destinationVariable': 'Destination variable',
  'webhookParameters.form.destinationAttachmentFileName': 'Attachment file name',
  'webhookParameters.form.destinationAttachmentContentType': 'Attachment content type',
  'webhookParameters.form.destinationTableRowPropertyValue': 'Table row property',

  'webhookParameters.form.select.Header': 'Header',
  'webhookParameters.form.select.Url': 'URL',
  'webhookParameters.form.select.FormData': 'Form Data',
  'webhookParameters.form.select.BodyJson': 'Body JSON',
  'webhookParameters.form.select.XWwwFormUrlEncoded': 'x-www-form-urlencoded',
  'webhookParameters.form.select.Authorization': 'Authorization',
  'webhookParameters.form.select.BodyText': 'Body text',
  'webhookParameters.form.select.FormFileData': 'Form file data',

  'webhookParameters.form.select.None': 'None',
  'webhookParameters.form.select.ByteArray': 'Byte array',
  'webhookParameters.form.select.Base64String': 'Base64 string',
  'webhookParameters.form.select.ZipByteArray': 'ZIP byte array',
  'webhookParameters.form.select.ZipBase64String': 'ZIP Base64 string',
  'webhookParameters.form.select.HttpBodyBinaryData': 'HTTP body binary data',

  'webhookParameters.form.select.FormField': 'Form field',
  'webhookParameters.form.select.Variable': 'Variable',
  'webhookParameters.form.select.InstanceName': 'Instance name',
  'webhookParameters.form.select.OperationObservations': 'Operation observations',
  'webhookParameters.form.select.OperationUserEmail': 'Operation user email',
  'webhookParameters.form.select.OperationIsApprovalOrReject': 'Is approval or reject',

  'webhookParameters.form.select.FieldValue': 'Field value',
  'webhookParameters.form.select.FieldSearchValue': 'Field search value',
};
